import React from 'react';
import { Facebook, Instagram, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-text text-white py-10" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-63">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-64">
          {/* Contact / Company Info */}
          <div data-id="element-65">
            <h4 className="font-bold text-xs uppercase tracking-wider text-brand-secondary mb-4" data-id="element-66">
              Contact
            </h4>
            <div className="space-y-2 text-xs text-gray-400" data-id="element-67">
              <p className="font-medium text-gray-300" data-id="element-68">
                SĂMĂRTINEAN ELENA-DANIELA
              </p>
              <p data-id="element-69">CABINET INDIVIDUAL DE PSIHOLOGIE</p>
              <p data-id="element-70">CIF: 41673080</p>
              <p data-id="element-71">Str. Avram Iancu, Nr.94, Brașov</p>
              <div className="pt-2 space-y-1.5" data-id="element-72">
                <a href="mailto:danielasamartinean2022@gmail.com" className="hover:text-white transition-colors flex items-center gap-1.5" data-id="element-73">
                  <Mail className="w-3.5 h-3.5" data-id="element-74" />
                  danielasamartinean2022@gmail.com
                </a>
                <p data-id="element-75">Telefon: +40742236028</p>
              </div>
            </div>
          </div>

          {/* Legal */}
          <div data-id="element-76">
            <h4 className="font-bold text-xs uppercase tracking-wider text-brand-secondary mb-4" data-id="element-77">
              Legal
            </h4>
            <ul className="space-y-2 text-xs text-gray-400" data-id="element-78">
              <li data-id="element-79">
                <a href="#" className="hover:text-white transition-colors" data-id="element-80">
                  Termeni și Condiții
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-white transition-colors" data-id="element-82">
                  Politica de Confidențialitate
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-white transition-colors" data-id="element-84">
                  Politica de Cookies
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="hover:text-white transition-colors" data-id="element-86">
                  ANPC
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div data-id="element-87">
            <h4 className="font-bold text-xs uppercase tracking-wider text-brand-secondary mb-4" data-id="element-88">
              Social Media
            </h4>
            <ul className="space-y-2 text-xs text-gray-400" data-id="element-89">
              <li data-id="element-90">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-91">
                  <Facebook className="w-4 h-4" data-id="element-92" />
                  Facebook
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-94">
                  <Instagram className="w-4 h-4" data-id="element-95" />
                  Instagram
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-96">
            <h4 className="font-bold text-xs uppercase tracking-wider text-brand-secondary mb-4" data-id="element-97">
              Linkuri Utile
            </h4>
            <ul className="space-y-2 text-xs text-gray-400" data-id="element-98">
              <li data-id="element-99">
                <a href="#despre" className="hover:text-white transition-colors" data-id="element-100">
                  Despre Mine
                </a>
              </li>
              <li data-id="element-101">
                <a href="#metoda" className="hover:text-white transition-colors" data-id="element-102">
                  Metoda 3S
                </a>
              </li>
              <li data-id="element-103">
                <a href="#servicii" className="hover:text-white transition-colors" data-id="element-104">
                  Servicii
                </a>
              </li>
              <li data-id="element-105">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-106">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 text-center text-[11px] text-gray-500" data-id="element-107">
          <p data-id="element-108">
            &copy; {new Date().getFullYear()} SĂMĂRTINEAN ELENA-DANIELA -
            CABINET INDIVIDUAL DE PSIHOLOGIE. Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>;
}